var _style, _script, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 264",
    style: {
      enableBackground: "new 0 0 192 264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:url(#SVGID_00000049917309220818382210000005712811086049796499_);}\r\n\t.st2{fill:url(#SVGID_00000117636631005001995950000004785241834824824204_);}\r\n\t.st3{fill:#14050D;}\r\n\t.st4{fill:#361808;}\r\n\t.st5{fill:url(#SVGID_00000071524175687091240700000001178704347494868639_);}\r\n\t.st6{fill:url(#SVGID_00000023243406637110851460000008523121791857945516_);}\r\n\t.st7{fill:url(#SVGID_00000095298921900887324620000007301906345778506671_);}\r\n\t.st8{fill:url(#SVGID_00000016757613394374585440000010211721965104625539_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000059280853043741852750000012157032605196007051_);}\r\n\t.st10{fill:url(#SVGID_00000039845778218391229190000005057110304907702173_);}\r\n\t.st11{fill:none;stroke:url(#SVGID_00000035505147302122092710000015869352010478642590_);stroke-width:1.6;}\r\n\t.st12{fill:url(#SVGID_00000112631519444060740950000011424659691716404127_);}\r\n\t.st13{fill:none;stroke:#F5931C;stroke-width:1.4;stroke-miterlimit:10;}\r\n\t.st14{fill:url(#SVGID_00000154407601469723599150000016654941931053587111_);}\r\n")), _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb",
    id: "argent-x-extension",
    xmlns: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.1084,
    y1: 84.722,
    x2: 99.1084,
    y2: 110.249,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    style: {
      stopColor: "#1D110F",
      stopOpacity: 0.4625
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8986,
    style: {
      stopColor: "#1D110F",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.1,180v-29.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059277984962044131510000011016011654343831177_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9492,
    y1: 105.319,
    x2: 99.9492,
    y2: 78.903,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5931C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059277984962044131510000011016011654343831177_)"
    },
    d: "M146,170.9c0,4.9-9.3,9.2-23,11.4 c-6.8,1.1-14.6,1.8-23,1.8c-8.4,0-16.2-0.6-23-1.8c-13.8-2.3-23-6.6-23-11.4c0-7.3,20.6-13.2,46-13.2 C125.4,157.7,146,163.6,146,170.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103258416746504226200000014959709662883099838_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9494,
    y1: 104.01,
    x2: 99.9494,
    y2: 80.203,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C100F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22190F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103258416746504226200000014959709662883099838_)"
    },
    d: "M144,170.9c0,4.4-8.9,8.3-22.1,10.3 c-6.5,1-14,1.6-22,1.6s-15.5-0.6-22-1.6c-13.2-2.1-22.1-5.9-22.1-10.3c0-6.6,19.7-11.9,44.1-11.9C124.3,159,144,164.3,144,170.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.1,170.9c0,0.3,0,0.5-0.1,0.8c-1.6-4.6-16.7-8.1-35-8.1c-18.4,0-33.4,3.6-35,8.1c-0.1-0.3-0.1-0.5-0.1-0.8 c0-4.9,15.7-8.9,35.2-8.9C119.4,161.9,135.1,165.9,135.1,170.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135,171.7c-1,3-7.8,5.5-17.5,7c-11.7,1.6-23.5,1.6-35.1,0c-9.7-1.4-16.4-4-17.5-7c1.6-4.6,16.7-8.1,35-8.1 C118.3,163.6,133.4,167.1,135,171.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101080331760612095580000006732942792709340562_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.5276,
    y1: 74.6494,
    x2: 145.8167,
    y2: 73.8675,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C110F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101080331760612095580000006732942792709340562_)"
    },
    d: "M146,170.9v22.9c0,7.3-20.6,13.2-46.1,13.2 c-25.4,0-46-5.9-46-13.2v-22.9c0,4.9,9.3,9.2,23,11.4c6.8,1.1,14.6,1.8,23,1.8c8.4,0,16.2-0.6,23-1.8 C136.7,180.1,146,175.8,146,170.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054251061862082128210000018280762339689248137_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.5823,
    y1: 143.3148,
    x2: 111.8844,
    y2: 119.5458,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D77E1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054251061862082128210000018280762339689248137_)"
    },
    d: "M108.6,115l-2.9-1.2c-1.5-0.6-3.1-1-4.7-1 c-0.1,0-0.3,0-0.4,0h-0.8l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0 l-0.2,0.1l-0.2,0l-0.2,0.1l-0.2,0l-0.3,0.1l-0.2,0l-0.3,0.1l-0.1,0l-0.3,0.1l-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2 c-2.2,0.9-4.3,2.2-6,3.9c-1.8,1.8-3.4,3.8-4.5,6.1c-1.2,2.3-2,4.7-2.4,7.3c-0.4,2.5-0.3,5,0.1,7.4c0.4,2.3,1.3,4.4,2.6,6.4l2.9,1.2 c-1.3-1.9-2.2-4.1-2.6-6.4c-0.5-2.4-0.5-4.9-0.1-7.4c0.4-2.5,1.2-5,2.4-7.3c1.2-2.3,2.7-4.3,4.5-6.1c1.7-1.7,3.8-3,6-3.9l0.4-0.2 l0.1,0c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.2-0.1l0.1,0l0.3-0.1l0.2,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2-0.1l0.2,0l0.2-0.1l0.2,0 c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0l0.2,0h0.8 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0C105.5,114,107.1,114.4,108.6,115z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053513061130759694020000017692757659895930760_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.0462,
    y1: 159.9287,
    x2: 126.3483,
    y2: 136.1597,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D77E1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053513061130759694020000017692757659895930760_)"
    },
    d: "M114.8,114.6l2.9,1.2c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0-0.1,0l0,0l-1.8,1.5c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,2.3c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0l-2.9-1.2c0,0,0,0,0,0 l0,0c0,0,0,0,0-0.1h0l0-2.3l2.7,1.2l-2.7-1.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1l1.8-1.5l0,0C114.7,114.6,114.7,114.6,114.8,114.6 C114.8,114.6,114.8,114.6,114.8,114.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057847141069937220810000005706298307974526094_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.6218,
    y1: 146.8061,
    x2: 114.9239,
    y2: 123.0371,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D77E1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057847141069937220810000005706298307974526094_)"
    },
    d: "M106.5,150l-2.9-1.2c1-9.9,4.1-19.5,9.2-28 l2.9,1.2C110.6,130.5,107.4,140.1,106.5,150z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058586173550768462870000012303928801491379372_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.8539,
    y1: 145.299,
    x2: 116.6897,
    y2: 120.566,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5931C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23140F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000058586173550768462870000012303928801491379372_)"
    },
    d: " M114.6,120.1c-1.2-1.8-2.8-3.3-4.7-4.4c-1.9-1.1-3.9-1.6-6.1-1.7c-0.1,0-0.3,0-0.4,0H103h-0.1h-0.3l-0.2,0l-0.2,0l-0.2,0l-0.2,0 l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0l-0.2,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0l-0.2,0l-0.2,0.1l-0.2,0 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0l-0.2,0l-0.3,0.1l-0.1,0c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0-0.1,0l-0.1,0l-0.4,0.2 c-2.2,0.9-4.3,2.2-6,3.9c-1.8,1.8-3.4,3.8-4.5,6.1c-1.2,2.3-2,4.7-2.4,7.3c-0.4,2.5-0.3,5,0.1,7.4c0.4,2.3,1.3,4.4,2.6,6.4 c5.9-1.2,11.7-4.3,16.5-8.9C108.6,132.6,112.4,126.7,114.6,120.1z M117.7,115.8C117.7,115.8,117.7,115.8,117.7,115.8 c0.1,0.1,0.1,0.1,0.1,0.1l0,2.3c0,0,0,0,0,0.1c0,0,0,0,0,0.1l-1.8,1.5c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1l0-2.3 c0,0,0,0,0-0.1c0,0,0,0,0-0.1l1.8-1.5C117.6,115.8,117.6,115.8,117.7,115.8C117.7,115.8,117.7,115.8,117.7,115.8z M114.6,141.6 c-2,3.6-4.8,6.5-8.1,8.4c1-9.9,4.1-19.5,9.2-28c1.2,2.5,1.9,5.3,1.9,8.1C117.6,134.1,116.6,138.1,114.6,141.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156589474263323299380000015296645753939486908_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0041,
    y1: 83.3747,
    x2: 100.0041,
    y2: 192.8118,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0228848,
    style: {
      stopColor: "#FDE5CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1474,
    style: {
      stopColor: "#F5931C",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    style: {
      stopColor: "#F5931C",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D110F",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156589474263323299380000015296645753939486908_)"
    },
    d: "M135.4,70.2c0,0,0.1,101.8,0,102 c-1,2.7-7.9,5.1-17.7,6.3c-11.8,1.5-23.7,1.5-35.5,0c-9.8-1.3-16.6-3.6-17.7-6.3c-0.1-0.2,0-102,0-102H135.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168815012405432340950000009494983409005810079_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4975,
    y1: 92.494,
    x2: 99.4975,
    y2: 116.206,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDD7AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D27E1D",
      stopOpacity: 0.04
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000168815012405432340950000009494983409005810079_)",
      strokeWidth: 1.6
    },
    d: " M144.8,157.3c0,1.4-1,2.9-3.3,4.5c-2.2,1.5-5.5,2.9-9.7,4.1c-8.3,2.4-19.7,3.8-32.4,3.8c-12.7,0-24.1-1.5-32.4-3.8 c-4.1-1.2-7.4-2.6-9.7-4.1c-2.3-1.5-3.3-3.1-3.3-4.5c0-1.4,1-2.9,3.3-4.5c2.2-1.5,5.5-2.9,9.7-4.1c8.3-2.4,19.7-3.8,32.4-3.8 c12.7,0,24.1,1.5,32.4,3.8c4.1,1.2,7.4,2.6,9.7,4.1C143.8,154.4,144.8,155.9,144.8,157.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176006719025287286560000009386374173819709609_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9492,
    y1: 205.9846,
    x2: 99.9492,
    y2: 179.5688,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D110F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D110F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176006719025287286560000009386374173819709609_)"
    },
    d: "M146,70.2c0,4.9-9.3,9.2-23,11.4 c-6.8,1.1-14.6,1.8-23,1.8c-8.4,0-16.2-0.6-23-1.8c-13.8-2.3-23-6.6-23-11.4c0-7.3,20.6-13.2,46-13.2C125.4,57,146,62.9,146,70.2z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M136,70c0,3.3-7.2,6.2-18,7.8c-5.3,0.8-11.4,1.2-18,1.2c-6.6,0-12.7-0.4-18-1.2c-10.8-1.6-18-4.5-18-7.8 c0-5,16.1-9,36-9C119.9,61,136,65,136,70z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059273851501433660220000011567273361909417654_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.5761,
    y1: 181.0356,
    x2: 145.881,
    y2: 180.2533,
    gradientTransform: "matrix(1 0 0 -1 0 263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#494654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C110F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059273851501433660220000011567273361909417654_)"
    },
    d: "M146,70.2v11.4c0,7.3-20.6,13.2-46.1,13.2 c-25.4,0-46-5.9-46-13.2V70.2c0,4.9,9.3,9.2,23,11.4c6.8,1.1,14.6,1.8,23,1.8c8.4,0,16.2-0.6,23-1.8C136.7,79.4,146,75.1,146,70.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.ce89552491db349693ff9c23e1533cd2.svg";
export { ForwardRef as ReactComponent };